import { drawInputSource1 } from '@/threejs/utils/canvasPatterns';
import type { InputSource } from './types';

export const grid1: InputSource = {
  label: 'Grid 1',
  value: 'grid1',
  draw: (ctx, width, height) => {
    drawInputSource1(ctx, width, height, 0, 0, false);
  },
};

export const grid1inverted: InputSource = {
  label: 'Grid 1 Inv',
  value: 'grid1inverted',
  draw: (ctx, width, height) => {
    drawInputSource1(ctx, width, height, 0, 0, true);
  },
};
